// extracted by mini-css-extract-plugin
export var errorBanner = "_c6-2";
export var scroller = "_c6-0";
export var thinking = "_c6-1";
export var visuallyHidden = "_c6-3";